import { uid } from 'radash';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    DiagramConnection,
} from 'models';

const coreSpecifications: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const { connections, componentInstances } = diagram;

    const errors: ComponentInstanceValidationError[] = [];
    const warning = (
        type: ComponentInstanceValidationError['type'],
        payload: ComponentInstanceValidationError['payload'],
    ) => {
        errors.push({
            id: uid(6),
            type,
            level: 'warning',
            payload,
        });
    };

    const checkEndpoint = (endpoint: DiagramConnection['from' | 'to']) => {
        const componentInstance = componentInstances[endpoint.componentInstanceId];

        if (componentInstance && !componentInstance.disabled && endpoint.port !== null) {
            const port = componentInstance.specifications.electrical.ports[endpoint.port];
            const voltageType = componentInstance.configuration.ports[endpoint.port]?.voltageType;

            if (port && voltageType) {
                // @ts-ignore
                const { current, voltage, power } = port[voltageType];

                if (current && current.nom === null && current.max === null) {
                    warning(ComponentInstanceValidationErrorType.CORE_SPECIFICATIONS_CURRENT, {
                        componentInstance,
                        portIndex: endpoint.port,
                    });
                }

                if (power && power.nom === null && power.max === null) {
                    warning(ComponentInstanceValidationErrorType.CORE_SPECIFICATIONS_POWER, {
                        componentInstance,
                        portIndex: endpoint.port,
                    });
                }

                if (voltage && voltage.nom === null) {
                    warning(ComponentInstanceValidationErrorType.CORE_SPECIFICATIONS_VOLTAGE, {
                        componentInstance,
                        portIndex: endpoint.port,
                    });
                }
            }
        }
    };

    Object.values(connections).forEach((connection) => {
        checkEndpoint(connection.from);
        checkEndpoint(connection.to);
    });

    return errors;
};

export { coreSpecifications };
